import { Budget } from '@/components/pages/edit-campaign/form-elements/budget';
import { Conversion } from '@/components/pages/edit-campaign/form-elements/conversion';
import { Cpa } from '@/components/pages/edit-campaign/form-elements/cpa';
import { Dates } from '@/components/pages/edit-campaign/form-elements/dates';
import { TargetBudget } from '@/components/pages/edit-campaign/target-budget';

export function DefaultForm() {
  return (
    <>
      <Dates />
      <Budget />
      <TargetBudget />
      <Cpa />
      <Conversion />
    </>
  );
}
